export default "__VITE_ASSET__DMRnxnRa__"